<template>
  <LayoutPage>
    <template #title>
      <v-toolbar-title class="headline">
        {{ `Management Dashboard Trend Report` }}
      </v-toolbar-title>
    </template>
    <v-sheet v-if="isAuthorizedUser && src" class="embedded-wrapper">
      <iframe :src="src" frameborder="0" class="embedded-content"></iframe>
    </v-sheet>
    <v-sheet v-else class="pa-4">
      <v-alert type="error">
        You are not authorized to view this report.
      </v-alert>
    </v-sheet>
  </LayoutPage>
</template>

<script>
import LayoutPage from "@layout/LayoutPage.vue";
import useUser from "./useUser";
import { computed } from "vue";

export default {
  name: "PageManagementDashboardTrendReport",
  components: {
    LayoutPage,
  },
  setup() {
    const { defaultOrganization, currentUser } = useUser();

    const isAuthorizedUser = computed(() => {
      const authorizedUsers = [
        "cpotash@citylinecapital.com",
        "helen@storage-defender.com",
      ];
      return authorizedUsers.includes(currentUser.value?.username);
    });

    const src = computed(() => {
      return "https://lookerstudio.google.com/embed/reporting/7d136631-6862-43be-9263-4e95a42eaf5a/page/tEnnC";
    });

    return {
      defaultOrganization,
      src,
      isAuthorizedUser,
    };
  },
};
</script>
